// *******************************************************************************
// Form handling
// *******************************************************************************

const handleForm = async (form, formAction, formK) => {
  const nonce = await getNonceForAction(formAction);
  const gCaptcha = document.querySelector('.g-captcha');
  const newsletterFormError = form.querySelector('.form__alert-error');

  const showError = (err) => {
    if (newsletterFormError) {
      newsletterFormError.classList.remove('hide');
      newsletterFormError.innerHTML = err;
    }
  };

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {
      'upload[]': {
        validators: {
          checkMaxFiles: {
            message: '',
          },
          checkFilesSize: {
            message: '',
          },
          checkFilesType: {
            message: '',
          },
        },
      },
    },
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) => element.closest('.mod-input,.checkbox,.dropdown,.upload-box__main'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .registerValidator('checkMaxFiles', fileCountValidator)
    .registerValidator('checkFilesSize', fileSizeValidator)
    .registerValidator('checkFilesType', fileTypeValidator)
    .on('core.element.validated', (e) => {
      const value = fv.getElementValue(e.field, e.element);
      const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox,.dropdown,.upload-box__main');
      const valueCheck = container.classList.contains('upload-box__main') ? filesToUpload.length === 0 : value === '';
      FormValidation.utils.classSet(container, {
        'is-validation-failed': valueCheck || !e.valid,
      });
    });

  if (uploadBox) {
    uploadBox.addEventListener('change', () => fv.validateField('upload[]'));
    uploadBox.addEventListener('fileRemoved', () => fv.validateField('upload[]'));
  }

  if (gCaptcha) {
    const axiosAction = async (formData) => {
      const token = await grecaptcha.execute(localData.captchaSiteKey, { action: formAction });

      const formDataInput = new FormData();
      formDataInput.append('action', formAction);
      formDataInput.append('k', formK);
      formDataInput.append('nonce', nonce);
      formDataInput.append('inputs', JSON.stringify(formData));
      if (filesToUpload) {
        Array.from(filesToUpload).forEach((file, index) => {
          formDataInput.append(`files_${index + 1}`, file.file);
        });
      }
      formDataInput.append('lang', localData.lang);
      formDataInput.append('id', localData.id);
      formDataInput.append('siteURL', window.location.href);
      formDataInput.append('token', token);

      ['contact-form', 'blog_hero_newsletter_form', 'newsletterModuleForm'].forEach((id) => {
        const form = document.querySelector(`#${id}`);
        if (form !== null) {
          const reusableModulePositionInRepeater = form.querySelector('[data-remod-repeat]');
          const reusableModulePosition = form.querySelector('[data-remod]');
          if (reusableModulePositionInRepeater) {
            formDataInput.append('remod-repeat', reusableModulePositionInRepeater.value);
          }
          if (reusableModulePosition) {
            formDataInput.append('remod', reusableModulePosition.value);
          }
        }
      });

      try {
        const response = await axios.post(localData.apiURL, formDataInput, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        const formDataParent = form.closest('[data-parent]');

        if (response.data.data.url) {
          window.location = response.data.data.url;
        } else {
          form.classList.remove('show-loader');
          formDataParent.classList.add('show-thankyou');
          form.scrollIntoView({
            behavior: 'smooth',
          });
        }
      } catch (error) {
        form.classList.remove('show-loader');
        showError(error.response.data.data.msg);
      }
    };

    fv.on('core.form.valid', () => {
      const formData = {};
      form.classList.add('show-loader');
      form.querySelectorAll('input, textarea').forEach((input) => {
        if (input.type === 'checkbox') {
          formData[input.id] = input.checked;
        } else if (input.type === 'radio' && input.checked) {
          if (input.dataset.type) {
            formData[input.name] = input.dataset.type;
          } else {
            formData[input.name] = input.closest('.dropdown__list-item').querySelector('label').innerHTML;
          }
        } else if (input.type !== 'checkbox' && input.type !== 'radio' && input.value.trim() !== '') {
          formData[input.name] = input.value.trim();
        }
      });
      const dropdown = form.querySelector('div.dropdown.is-selected');
      if (dropdown) {
        formData.dropdown = dropdown.querySelector('.dropdown__placeholder-text').innerHTML;
        formData.dropdownValue = dropdown.querySelector('.dropdown__placeholder-text').dataset.ehrm;
      }

      axiosAction(formData);
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  ['form-component', 'blog_hero_newsletter_form', 'newsletterModuleForm'].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      const formK = form.querySelector('[data-k]');
      let formKValue = 0;
      if (formK) {
        formKValue = formK.value;
      }
      handleForm(form, formAction, formKValue);
    }
  });
});
